import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { set_supplier_list, set_product_list, set_page_refresh, set_order_list, set_courier_list } from '../../core/redux/action';
import { useDispatch, useSelector } from 'react-redux';
import EditCareSales from '../../core/modals/sales/editcarsales';
import axios from 'axios';
import Select from 'react-select';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import UploadDocuments from '../../core/modals/sales/uploaddocuments';
// import Table from '../../core/pagination/datatable';
import Table2 from '../../core/pagination/datatable2'
import { dateFormatter, dateFormatter2, getCurrencySymbol } from '../../plugins/helper';
import { APIgetStores } from "../../api/settings.ts";
import InvoiceDownloader from '../../core/modals/sales/InvoiceDownloader'
const CarOrders = () => {
    const dispatch = useDispatch();
    const dataSource = useSelector((state) => state.order_list || []);
    const pageRefresh = useSelector((state) => state.pageRefresh?.saleslist || 0);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [storeOption, setStoreOption] = useState([]);
    const [selectedStore, setSelectedStore] = useState('');
    const language = useSelector((state) => state.language || 'en');
    const translation = useSelector((state) => state.translation || {});
    const [dataStore, setDataStore] = useState([])
    const MySwal = withReactContent(Swal);
    const permissions = useSelector((state) => state.permissions) || [];
    const roleTitle = useSelector((state) => state.roleTitle) || '';
    const roleTitleAdmin = useSelector((state) => state.roleTitleAdmin) || '';
    const [searchTerm, setSearchTerm] = useState("");
    const canView = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'orders' && p.Permission.toLowerCase() === 'view');
    const canUpdate = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'orders' && p.Permission.toLowerCase() === 'update');
    const canDelete = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'orders' && p.Permission.toLowerCase() === 'delete');
    const [filteredOrders, setFilteredOrders] = useState([]);
    const courierList = useSelector((state) => state.courier_list);
   
     const getStoreApi2 = async () => {
        
        const res = await APIgetStores({});
        if(res?.response?.stores){
          const storeData = res.response.stores || [];
          console.log("storeData",storeData);
          setDataStore(storeData)
    
        }    
      };

    useEffect(() => {
        getStoreApi2();
    }, []);
    async function fetchOrders() {
        try {
            const storeIds = localStorage.getItem('storeIds');
            const result = await axios.get("gettenantorders/", {
                params: {
                  storeIds: storeIds, // Add query parameters here
                  sortDesc: "createdAt"
                },
              });
            dispatch(set_order_list(result.data.orders));
        } catch (error) {
            console.error("Error fetching orders:", error);
        }
    }
    useEffect(() => {
       fetchOrders();
    }, [pageRefresh, dispatch]);

    useEffect(() => {
        async function fetchData() {
          let result = await axios.get("getcourierconfig/");
          dispatch(set_courier_list(result.data.data))
        }
        fetchData();
      }, [pageRefresh]);

    const getCourierDetails = (country, storeId, courierType, courierList) => {
        // Find the matching country object
        const countryData = courierList.find(
            (item) =>
                item.country === country &&
                item.stores.some(store => store.storeId === storeId)
        );
    
        if (!countryData) {
            return null; // No matching country or store found
        }
    
        // Find the matching courier details for the courier type
        const courierDetail = countryData.courierDetails.find(
            (detail) => detail.courierType === courierType
        );
    
        return courierDetail || null; // Return the courier detail or null if not found
    };
    function getStoreDetailsById(id) {
        
        const storesData = JSON.parse(localStorage.getItem('allStores')); 
        // console.log("allStores",storesData);
        const store = storesData.find(item => item._id === id);
        if (!store) {
            return `No store found with _id: ${id}`;
        }
        return {
            title: store.title || "",
            storeNumber: store.storeNumber ||"",
            address: store.address || "",
            cityId: store.cityId || "KHI",
            phone: store.phone || "",
            email: store.email || "",
            country: store.locationDetails?.country?.toUpperCase() || 'Pakistan'
        };
    }

    const handleGenerateInvoice = async (record, courierType) => {
        const cour = getCourierDetails(record?.shippingAddress?.country || "Pakistan", record.storeId || "", courierType || "", courierList || null);
      
        const {baseUrl, authToken, accessToken, portalCode} = cour;
        if(!baseUrl || !authToken || !accessToken || !portalCode)
        {
            alert("Configurations not found");
            return;
        }
        const apiUrl = baseUrl+"booking/create";//'https://devconnect.tcscourier.com/ecom/api/booking/create';
        const currentDate = new Date();
        const storeDetails = getStoreDetailsById(record.storeId)
        const data = {
            accesstoken: accessToken,//'jcgwsU85g+loIFikVpysYT4QQ1WUQ/0sycayn1fOKUHbanhNc4Hix21+9FtBgTNT+17xcw8hCA/m0WKWvjlWdkCRRamFiwoEIcst9yGRPksWtzlYzAeo2sIQBv6vbf8H9v1FjLDWB1vgfwuupewDYhB4xoPKGpg17elVfxdpJPM=',
            shipperinfo: {
                tcsaccount: '759464',//04011K1 account
                shippername: storeDetails.title,//storeDetails.title,//'Test',
                address1: storeDetails.address,//storeDetails.address,//'Test address 1',
                //zip: '75800',
                countrycode: storeDetails.country,//'PK',
                countryname: 'Pakistan',
                citycode: 'SGD',
                cityname: "Sargodha",//storeDetails.cityId,//'x',
                mobile: storeDetails.phone//storeDetails.phone,
            },
            consigneeinfo: {
                consigneecode: 'C103',//'C103',
                firstname: record.shippingAddress.name,
                lastname: '',
                address1: record.shippingAddress.address +", "+record.shippingAddress.area+", "+record.shippingAddress.state,
                countrycode: 'PK',
                countryname: record.shippingAddress.country,
              //  citycode: 'KHI',
                cityname: record.shippingAddress.area,//'Karachi',
                mobile: record.shippingAddress.contactNo,
            },
            shipmentinfo: {
                costcentercode: portalCode,//??? portalCode
                referenceno: record._id,
                contentdesc: '',
                servicecode: 'O',
                parametertype: 'Parameter Type',
                shipmentdate: formatDate(currentDate),
                shippingtype: '',
                currency: record.currency.toUpperCase() || 'PKR',//'PKR',
                codamount: record.grossTotal,
                weightinkg: 0.5,
                pieces: 1,
                fragile: false,
                remarks: '',
                // skus: [
                //     {
                //         description: 'SKU description',
                //         quantity: 1,
                //         weight: 0.5,
                //         uom: 'KG',
                //         unitprice: 250,
                //         declaredvalue: null,
                //         insuredvalue: null,
                //     },
                // ],
            },
        };
    
        try {
            const response = await axios.post(apiUrl, data, {
                headers: {
                    accept: '*/*',
                    Authorization: "Bearer "+authToken,//`Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjpbIlRyYWNrIiwiRWNvbSJdLCJjbGllbnRpZCI6IjIxNTYxMDA1OSIsInNlcnZpY2VzIjoiIiwiZXhjbHVkZWQtc2VydmljZXMiOiIiLCJpc3MiOiJ1YXQtbWlkZGxld2FyZS50cmFuenVtcGsuY29tIiwianRpIjoiYWI4MTVmMDEtNDRhOC00MjhlLWI0MGYtNTA5NzRmZTQwN2QyIiwibmJmIjoxNzM0MDc2NDA4LCJleHAiOjE4MjA0NzY0MDgsImlhdCI6MTczNDA3NjQwOH0.Vj2LvEk98Ii72pWaOOsLMu7AfhNJ3WNPdmiyybQ7aAc`,
                    'Content-Type': 'application/json-patch+json',
                },
            });
            if (response?.data?.consignmentNo) {
                await axios.post('updateconsignmentnobyorderid/', {_id: record?._id,consignmentNo: response?.data?.consignmentNo });

                fetchOrders();
                MySwal.fire({
                    icon: 'success',
                    title: 'Invoice Generated Successfully',
                    text: 'Your invoice has been generated.',
                });
            }
            else
            {
                MySwal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: response?.data?.message,
                });
            }
        } catch (error) {
            console.error('Error generating invoice:', error);
            MySwal.fire({
                icon: 'error',
                title: 'Error',
                text: 'There was an error generating the invoice.',
            });
        }
    };
    const formatDate = (date) => {
        const pad = (n) => (n < 10 ? '0' + n : n);
        return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    };
    const handleDownload = async (record, courierType, consignmentno) => {
        if (!consignmentno) {
            MySwal.fire('Error', 'Please select a valid record with a consignment number.', 'error');
            return;
        }

        const cour = getCourierDetails(record?.shippingAddress?.country || "Pakistan", record.storeId || "", courierType || "", courierList || null);
        console.log("cour",cour);
        const {baseUrl, authToken, accessToken} = cour;
        console.log("authToken",authToken);
        console.log("accessToken",accessToken);
        const apiUrl = baseUrl+"print/label";//`https://devconnect.tcscourier.com/ecom/api/print/label`;
        const params = {
            accesstoken: accessToken,// 'jcgwsU85g+loIFikVpysYT4QQ1WUQ/0sycayn1fOKUHbanhNc4Hix21+9FtBgTNT+17xcw8hCA/m0WKWvjlWdkCRRamFiwoEIcst9yGRPksWtzlYzAeo2sIQBv6vbf8H9v1FjLDWB1vgfwuupewDYhB4xoPKGpg17elVfxdpJPM=',
            consignmentno: consignmentno,
            shipperDetails: false,
        };

        try {
            const response = await axios.get(apiUrl, {
                params,
                headers: {
                    Authorization: "Bearer "+authToken,//`Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjpbIlRyYWNrIiwiRWNvbSJdLCJjbGllbnRpZCI6IjIxNTYxMDA1OSIsInNlcnZpY2VzIjoiIiwiZXhjbHVkZWQtc2VydmljZXMiOiIiLCJpc3MiOiJ1YXQtbWlkZGxld2FyZS50cmFuenVtcGsuY29tIiwianRpIjoiYWI4MTVmMDEtNDRhOC00MjhlLWI0MGYtNTA5NzRmZTQwN2QyIiwibmJmIjoxNzM0MDc2NDA4LCJleHAiOjE4MjA0NzY0MDgsImlhdCI6MTczNDA3NjQwOH0.Vj2LvEk98Ii72pWaOOsLMu7AfhNJ3WNPdmiyybQ7aAc`,
                    Accept: '*/*',
                },
                responseType: 'blob', // Ensure the response is treated as a file
            });
            console.log("response",response.data);

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `invoice_${consignmentno}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {//Maheen OLX
            MySwal.fire('Error', 'Failed to download the file. Please try again.', 'error');
        }
    };
    const handleCancel = async (record, courierType, consignmentno) => {
        if (!consignmentno) {
            MySwal.fire('Error', 'Please select a valid record with a consignment number.', 'error');
            return;
        }
        const cour = getCourierDetails(record?.shippingAddress?.country || "Pakistan", record.storeId || "", courierType || "", courierList || null);
        console.log("cour",cour);
        const {baseUrl, authToken, accessToken} = cour;
        const apiUrl = baseUrl+ 'booking/cancel';//`https://devconnect.tcscourier.com/ecom/api/booking/cancel`;
        const data = {
            accesstoken: accessToken,//'jcgwsU85g+loIFikVpysYT4QQ1WUQ/0sycayn1fOKUHbanhNc4Hix21+9FtBgTNT+17xcw8hCA/m0WKWvjlWdkCRRamFiwoEIcst9yGRPksWtzlYzAeo2sIQBv6vbf8H9v1FjLDWB1vgfwuupewDYhB4xoPKGpg17elVfxdpJPM=',
            consignmentnumber: consignmentno
        };

        try {
            const response = await axios.post(apiUrl, data, {
                headers: {
                    accept: '*/*',
                    Authorization: "Bearer "+authToken,//eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjpbIlRyYWNrIiwiRWNvbSJdLCJjbGllbnRpZCI6IjIxNTYxMDA1OSIsInNlcnZpY2VzIjoiIiwiZXhjbHVkZWQtc2VydmljZXMiOiIiLCJpc3MiOiJ1YXQtbWlkZGxld2FyZS50cmFuenVtcGsuY29tIiwianRpIjoiYWI4MTVmMDEtNDRhOC00MjhlLWI0MGYtNTA5NzRmZTQwN2QyIiwibmJmIjoxNzM0MDc2NDA4LCJleHAiOjE4MjA0NzY0MDgsImlhdCI6MTczNDA3NjQwOH0.Vj2LvEk98Ii72pWaOOsLMu7AfhNJ3WNPdmiyybQ7aAc`,
                    'Content-Type': 'application/json-patch+json',
                },
            });
            console.log("handleCancel response",response);
            await axios.post('updateconsignmentnobyorderid/', {_id: record._id,consignmentNo: null });

            fetchOrders();
        } catch (error) {//Maheen OLX
            MySwal.fire('Error', 'Failed to download the file. Please try again.', 'error');
        }
    };
    
    useEffect(() => {
        async function fetchInitialData() {
            try {
                const [suppliers, products] = await Promise.all([
                    axios.get('getusersuppliers/'),
                    axios.get('getuserproducts/')
                ]);

                dispatch(set_supplier_list(suppliers.data));
                dispatch(set_product_list(products.data));

                const storeOptionsList = localStorage.getItem('storeOptionsList');
                if (storeOptionsList) {
                    setStoreOption(JSON.parse(storeOptionsList));
                }
            } catch (error) {
                console.error("Error fetching initial data:", error);
            }
        }
        fetchInitialData();
    }, [dispatch]);

    const columns = [
      {
        title: "Actions",
        key: "actions",
        render: (_, record) => {
            const manualPayments = record.manualPayments || [];
            const addiPayment = record.tAddiPayment || 0;
            const grossTotal = record.grossTotal || 0;

            return (
            <div className="d-flex align-items-center gap-2">
                {/* InvoiceDownloader component */}
                <div>
                    <InvoiceDownloader
                        data={{
                            manualPayments,
                            addiPayment,
                            totalPaid: manualPayments.reduce((sum, item) => sum + item.amount, 0) + Number(addiPayment),
                            totalCost: grossTotal,
                            orderInfo: record,
                            dataStore: dataStore
                        }}
                    />
                </div>
                <div>
                    {canUpdate && (
                        <Link
                            className="me-2 p-2"
                            onClick={() => setSelectedRecord(record)}
                            data-bs-toggle="modal"
                            data-bs-target="#modal_upload_documents"
                        >
                     
                        <i className="fas fa-upload" />
                        </Link>
                    )}
                </div>
                {/* Action buttons */}
                <div className="edit-delete-action d-flex">
                {canUpdate && (
                    <Link
                    className="me-2 p-2"
                    onClick={() => setSelectedRecord(record)}
                    data-bs-toggle="modal"
                    data-bs-target="#add-units"
                    >
                    <i data-feather="edit" className="feather-edit" />
                    </Link>
                )}
                {canDelete && (
                    <Link className="confirm-text p-2" to="#" onClick={() => showConfirmationAlert(record)}>
                    <i data-feather="trash-2" className="feather-trash-2" />
                    </Link>
                )}
                </div>
            </div>
            );
        }
        },
        
        {
            title: translation[language]?.["chassis_number"] || "Chassis Number",
            dataIndex: "chassisNumbers",
            render: (chassisNumbers) => chassisNumbers?.length ? chassisNumbers.join(", ") : "-",
        },
        {
            title: translation[language]?.["customer"] || "Customer",
            dataIndex: "shippingAddress",
            render: (text) => <span>{text?.name || ""}</span>,
        },
        {
            title: translation[language]?.["order_date"] || "Order Date",
            dataIndex: "createdAt",
            render: (text) => text? <span>{dateFormatter(text, language)}</span> : <span>-</span>
        },
        {
            title: translation[language]?.["departure_date"] || "Departure Date",
            dataIndex: "departureDate",
            render: (text) => text ? <span>{dateFormatter2(text)}</span> : <span>-</span>
        },
        
        {
            title: translation[language]?.["total_amount"] || "Total Amount",
            dataIndex: "grossTotal",
            render: (value) => `${getCurrencySymbol()}${(value || 0).toLocaleString()}`
            
        },
        {
            title: translation[language]?.["amount_paid"] || "Amount Paid",
            dataIndex: "totalPaid",
            render: (value) => `${getCurrencySymbol()}${(value || 0).toLocaleString()}`
        },
        {
            title: translation[language]?.["balance"] || "Balance",
            render: (_, record) => {
                const grossTotal = record.grossTotal || 0;
                const totalPaid = record.totalPaid || 0;
              
                const balance = grossTotal - totalPaid;
                return `${getCurrencySymbol()}${balance.toLocaleString()}`; // or just `balance` if you don’t want formatting
            }
        },
        {
            title: translation[language]?.["paid_percentage"] || "Paid %",
            render: (_, record) => {
                const grossTotal = record.grossTotal || 0;
                const totalPaid = record.totalPaid || 0;
                const percentage = grossTotal > 0 ? (totalPaid / grossTotal) * 100 : 0;
                return `${percentage.toFixed(0)}%`;
            }
        },

        {
            title: translation[language]?.["recieved_misc"] || "Recieved Misc",
            dataIndex: "tAddiPayment",
            render: (value) => `${getCurrencySymbol()}${(value || 0).toLocaleString()}`
        },
        {
            title: translation[language]?.["payment_status"] || "Payment Status",
            dataIndex: "saleStatus",
            render: (text) => {
                const statusStyles = {
                    received: { backgroundColor: "#3D8E03", color: "white" },
                    pending: { backgroundColor: "#EBAC0A", color: "white" },
                    returned: { backgroundColor: "#E30404", color: "white" },
                    default: { backgroundColor: "#E30404", color: "white" },
                };
                return (
                    <span className="badge-linesuccess capitalize" style={statusStyles[text] || statusStyles.default}>
                        {translation[language]?.[text.toLowerCase()] || text}
                    </span>
                );
            },
        },
        {
            title: translation[language]?.["order_status"] || "Order Status",
            dataIndex: "transitStatus",
            render: (text) => {
                const statusStyles = {
                    Packing: { backgroundColor: "#CD31E7", color: "white" },
                    ConfirmOrder: { backgroundColor: "#0d6efd", color: "white" },
                    Shipped: { backgroundColor: "#EBAC0A", color: "white" },
                    Delivered: { backgroundColor: "#3D8E03", color: "white" },
                    Cancelled: { backgroundColor: "#E30404", color: "white" },
                    Refunded: { backgroundColor: "brown", color: "white" },
                    default: { backgroundColor: "#E30404", color: "white" },
                };
                return (
                    <span className="badge-linesuccess capitalize" style={statusStyles[text] || statusStyles.default}>
                        {translation[language]?.[text.toLowerCase()] || text}
                    </span>
                );
            },
        },
        {
            title: translation[language]?.["order_number"] || "Order Number",
            dataIndex: "_id",
        },
       
    ];
    
    if (courierList?.length > 0) {
        columns.push({
            title: translation[language]?.["Generate_Courier_Label"] || "Generate Courier Label",
            render: (text, record) => (
                <>
                    {!record.consignmentNo ? (
                        <button
                            onClick={() => handleGenerateInvoice(record, 'tcs')}
                            className="btn btn-primary"
                        >
                            {translation[language]?.["create_tcs_booking"] || "Create Tcs Booking"}
                        </button>
                    ) : (
                        <>
                            <button
                                onClick={() =>
                                    handleCancel(
                                        record,
                                        'tcs',
                                        record._id,
                                        record.consignmentNo || "173000144860"
                                    )
                                }
                                className="btn btn-primary me-2"
                            >
                                {translation[language]?.["cancel_booking"] || "Cancel Booking"}
                            </button>
    
                            <button
                                onClick={() =>
                                    handleDownload(record, 'tcs', record.consignmentNo || "173000144860")
                                }
                                className="btn btn-primary"
                            >
                                {translation[language]?.["download_label"] || "Download Label"}
                            </button>
                        </>
                    )}
                </>
            ),
        });
    }
    const filteredDataSource = selectedStore
        ? dataSource.filter(order => order.storeId === selectedStore)
        : dataSource;

    useEffect(() => {
        const filtered = filteredDataSource.filter(order =>
            (order._id && order._id.toLowerCase().includes(searchTerm.toLowerCase())) ||
            (order.shippingAddress.name && order.shippingAddress.name.toLowerCase().includes(searchTerm.toLowerCase())) ||
            (Array.isArray(order.chassisNumbers) && order.chassisNumbers.some(chassis =>
            chassis.toLowerCase().includes(searchTerm.toLowerCase())
        ))
        );

        setFilteredOrders(filtered);
    }, [searchTerm, dataSource]);


 

    const showConfirmationAlert = (record) => {
        MySwal.fire({
            title: translation[language]?.["are_you_sure?"] || "Are you sure?",
            text: translation[language]?.["you_won't_be_able_to_revert_this!"] || "You won't be able to revert this!",
            showCancelButton: true,
            confirmButtonColor: "#00ff00",
            confirmButtonText: translation[language]?.["yes,_delete_it!"] || "Yes, delete it!",
            cancelButtonColor: "#ff0000",
            cancelButtonText: translation[language]?.["cancel"] || "Cancel",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await axios.post("removeorder/", record);
                    dispatch(set_page_refresh("saleslist"));
                    MySwal.fire({
                        title: translation[language]?.["deleted!"] || "Deleted!",
                        text: translation[language]?.["item_has_been_deleted."] || "Item has been deleted.",
                        confirmButtonText: translation[language]?.["ok"] || "OK",
                    });
                } catch (e) {
                    console.error(e);
                }
            }
        });
    };

    return (
        <div>
            {canView ? (
                <div className={`${language === 'ar' ? 'page-wrapper-rtl' : 'page-wrapper'}`}>
                    <div className="content">
                        <div className="page-header">
                            <div className="add-item d-flex">
                                <div className="page-title">
                                    <h4>{translation[language]?.["orders_list"] || "Orders List"}</h4>
                                    <h6>{translation[language]?.["manage_your_orders"] || "Manage Your Orders"}</h6>
                                </div>
                            </div>
                            
                         <div className="search-set" style={{marginLeft: "auto"}}>
                            <div className="search-input">
                                <Select
                                        className="select"
                                        options={storeOption}
                                        value={storeOption.find(option => option.value === selectedStore)}
                                        onChange={(option) => setSelectedStore(option.value)}
                                        placeholder={translation[language]?.["all_stores"] || "All Stores"}
                                        styles={{ container: (provided) => ({ ...provided, minWidth: '200px' }) }}
                                    />
                            
                            </div>
                            <div className="search-input">
                                <input
                                    type="text"
                                    placeholder={translation?.[language]?.["search"] || "Search"}
                                    className="form-control"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                                <span to="#" className="btn btn-searchset" style={{ paddingTop: "10px"}}>
                                    <i className="feather-search" />
                                </span>
                            </div>
                             </div>
                        </div>
                        <div className="card table-list-card">
                            <div className="card-body">
                                <div className="table-responsive">
                                    <Table2 columns={columns} dataSource={filteredOrders} />
                                </div>
                            </div>
                        </div>
                        {selectedRecord &&
                            <>
                                <EditCareSales record={selectedRecord} dataStore={dataStore} />
                                <UploadDocuments record={selectedRecord} dataStore={dataStore} />
                            </>
                        }
                    </div>
                </div>
            ) : (
                <div>
                    <p>{translation[language]?.["you_don't_have_permission_to_view_this_page"] || "You don't have permission to view this page"}</p>
                </div>
            )}
        </div>
    );
};

export default CarOrders;

// old
// import React, { useEffect, useState } from 'react';
// import { Link } from 'react-router-dom';
// import { set_supplier_list, set_product_list, set_page_refresh, set_order_list, set_courier_list } from '../../core/redux/action';
// import { useDispatch, useSelector } from 'react-redux';
// import EditSales from '../../core/modals/sales/editsales';
// import axios from 'axios';
// import Select from 'react-select';
// import Swal from 'sweetalert2';
// import withReactContent from 'sweetalert2-react-content';
// import Table from '../../core/pagination/datatable';
// import { dateFormatter } from '../../plugins/helper';

// const SalesList = () => {
//     const dispatch = useDispatch();
//     const dataSource = useSelector((state) => state.order_list || []);
//     const pageRefresh = useSelector((state) => state.pageRefresh?.saleslist || 0);
//     const [selectedRecord, setSelectedRecord] = useState(null);
//     const [storeOption, setStoreOption] = useState([]);
//     const [selectedStore, setSelectedStore] = useState('');
//     const language = useSelector((state) => state.language || 'en');
//     const translation = useSelector((state) => state.translation || {});

//     const MySwal = withReactContent(Swal);
//     const permissions = useSelector((state) => state.permissions) || [];
//     const roleTitle = useSelector((state) => state.roleTitle) || '';
//     const roleTitleAdmin = useSelector((state) => state.roleTitleAdmin) || '';

//     const canView = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'orders' && p.Permission.toLowerCase() === 'view');
//     const canUpdate = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'orders' && p.Permission.toLowerCase() === 'update');
//     const canDelete = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'orders' && p.Permission.toLowerCase() === 'delete');
    
    
//     async function fetchOrders() {
//         try {
//             const storeIds = localStorage.getItem('storeIds');
//             const result = await axios.get("gettenantorders/", {
//                 params: {
//                   storeIds: storeIds, // Add query parameters here
//                   sortDesc: "createdAt"
//                 },
//               });
//             dispatch(set_order_list(result.data.orders));
//         } catch (error) {
//             console.error("Error fetching orders:", error);
//         }
//     }
//     useEffect(() => {
//        fetchOrders();
//     }, [pageRefresh, dispatch]);

//     useEffect(() => {
//         async function fetchData() {
//           let result = await axios.get("getcourierconfig/");
//           dispatch(set_courier_list(result.data.data))
//         }
//         fetchData();
//       }, [pageRefresh]);
//     const courierList = useSelector((state) => state.courier_list);
//     console.log("courierList",courierList);

//     const getCourierDetails = (country, storeId, courierType, courierList) => {
//         // Find the matching country object
//         const countryData = courierList.find(
//             (item) =>
//                 item.country === country &&
//                 item.stores.some(store => store.storeId === storeId)
//         );
    
//         if (!countryData) {
//             return null; // No matching country or store found
//         }
    
//         // Find the matching courier details for the courier type
//         const courierDetail = countryData.courierDetails.find(
//             (detail) => detail.courierType === courierType
//         );
    
//         return courierDetail || null; // Return the courier detail or null if not found
//     };
//     function getStoreDetailsById(id) {
        
//         const storesData = JSON.parse(localStorage.getItem('allStores')); 
//         // console.log("allStores",storesData);
//         const store = storesData.find(item => item._id === id);
//         if (!store) {
//             return `No store found with _id: ${id}`;
//         }
//         return {
//             title: store.title || "",
//             storeNumber: store.storeNumber ||"",
//             address: store.address || "",
//             cityId: store.cityId || "KHI",
//             phone: store.phone || "",
//             email: store.email || "",
//             country: store.locationDetails?.country?.toUpperCase() || 'Pakistan'
//         };
//     }

//     const handleGenerateInvoice = async (record, courierType) => {
//         const cour = getCourierDetails(record?.shippingAddress?.country || "Pakistan", record.storeId || "", courierType || "", courierList || null);
//         console.log("handleGenerateInvoice cour",cour);
//         const {baseUrl, authToken, accessToken, portalCode} = cour;
//         if(!baseUrl || !authToken || !accessToken || !portalCode)
//         {
//             alert("Configurations not found");
//             return;
//         }
//         const apiUrl = baseUrl+"booking/create";//'https://devconnect.tcscourier.com/ecom/api/booking/create';
//         const currentDate = new Date();
//         const storeDetails = getStoreDetailsById(record.storeId)
//         const data = {
//             accesstoken: accessToken,//'jcgwsU85g+loIFikVpysYT4QQ1WUQ/0sycayn1fOKUHbanhNc4Hix21+9FtBgTNT+17xcw8hCA/m0WKWvjlWdkCRRamFiwoEIcst9yGRPksWtzlYzAeo2sIQBv6vbf8H9v1FjLDWB1vgfwuupewDYhB4xoPKGpg17elVfxdpJPM=',
//             shipperinfo: {
//                 tcsaccount: '759464',//04011K1 account
//                 shippername: storeDetails.title,//storeDetails.title,//'Test',
//                 address1: storeDetails.address,//storeDetails.address,//'Test address 1',
//                 //zip: '75800',
//                 countrycode: storeDetails.country,//'PK',
//                 countryname: 'Pakistan',
//                 citycode: 'SGD',
//                 cityname: "Sargodha",//storeDetails.cityId,//'x',
//                 mobile: storeDetails.phone//storeDetails.phone,
//             },
//             consigneeinfo: {
//                 consigneecode: 'C103',//'C103',
//                 firstname: record.shippingAddress.name,
//                 lastname: '',
//                 address1: record.shippingAddress.address +", "+record.shippingAddress.area+", "+record.shippingAddress.state,
//                 countrycode: 'PK',
//                 countryname: record.shippingAddress.country,
//               //  citycode: 'KHI',
//                 cityname: record.shippingAddress.area,//'Karachi',
//                 mobile: record.shippingAddress.contactNo,
//             },
//             shipmentinfo: {
//                 costcentercode: portalCode,//??? portalCode
//                 referenceno: record._id,
//                 contentdesc: '',
//                 servicecode: 'O',
//                 parametertype: 'Parameter Type',
//                 shipmentdate: formatDate(currentDate),
//                 shippingtype: '',
//                 currency: record.currency.toUpperCase() || 'PKR',//'PKR',
//                 codamount: record.grossTotal,
//                 weightinkg: 0.5,
//                 pieces: 1,
//                 fragile: false,
//                 remarks: '',
//                 // skus: [
//                 //     {
//                 //         description: 'SKU description',
//                 //         quantity: 1,
//                 //         weight: 0.5,
//                 //         uom: 'KG',
//                 //         unitprice: 250,
//                 //         declaredvalue: null,
//                 //         insuredvalue: null,
//                 //     },
//                 // ],
//             },
//         };
    
//         try {
//             const response = await axios.post(apiUrl, data, {
//                 headers: {
//                     accept: '*/*',
//                     Authorization: "Bearer "+authToken,//`Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjpbIlRyYWNrIiwiRWNvbSJdLCJjbGllbnRpZCI6IjIxNTYxMDA1OSIsInNlcnZpY2VzIjoiIiwiZXhjbHVkZWQtc2VydmljZXMiOiIiLCJpc3MiOiJ1YXQtbWlkZGxld2FyZS50cmFuenVtcGsuY29tIiwianRpIjoiYWI4MTVmMDEtNDRhOC00MjhlLWI0MGYtNTA5NzRmZTQwN2QyIiwibmJmIjoxNzM0MDc2NDA4LCJleHAiOjE4MjA0NzY0MDgsImlhdCI6MTczNDA3NjQwOH0.Vj2LvEk98Ii72pWaOOsLMu7AfhNJ3WNPdmiyybQ7aAc`,
//                     'Content-Type': 'application/json-patch+json',
//                 },
//             });
//             if (response?.data?.consignmentNo) {
//                 await axios.post('updateconsignmentnobyorderid/', {_id: record?._id,consignmentNo: response?.data?.consignmentNo });

//                 fetchOrders();
//                 MySwal.fire({
//                     icon: 'success',
//                     title: 'Invoice Generated Successfully',
//                     text: 'Your invoice has been generated.',
//                 });
//             }
//             else
//             {
//                 MySwal.fire({
//                     icon: 'error',
//                     title: 'Error',
//                     text: response?.data?.message,
//                 });
//             }
//         } catch (error) {
//             console.error('Error generating invoice:', error);
//             MySwal.fire({
//                 icon: 'error',
//                 title: 'Error',
//                 text: 'There was an error generating the invoice.',
//             });
//         }
//     };
//     const formatDate = (date) => {
//         const pad = (n) => (n < 10 ? '0' + n : n);
//         return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
//     };
//     const handleDownload = async (record, courierType, consignmentno) => {
//         if (!consignmentno) {
//             MySwal.fire('Error', 'Please select a valid record with a consignment number.', 'error');
//             return;
//         }

//         const cour = getCourierDetails(record?.shippingAddress?.country || "Pakistan", record.storeId || "", courierType || "", courierList || null);
//         console.log("cour",cour);
//         const {baseUrl, authToken, accessToken} = cour;
//         console.log("authToken",authToken);
//         console.log("accessToken",accessToken);
//         const apiUrl = baseUrl+"print/label";//`https://devconnect.tcscourier.com/ecom/api/print/label`;
//         const params = {
//             accesstoken: accessToken,// 'jcgwsU85g+loIFikVpysYT4QQ1WUQ/0sycayn1fOKUHbanhNc4Hix21+9FtBgTNT+17xcw8hCA/m0WKWvjlWdkCRRamFiwoEIcst9yGRPksWtzlYzAeo2sIQBv6vbf8H9v1FjLDWB1vgfwuupewDYhB4xoPKGpg17elVfxdpJPM=',
//             consignmentno: consignmentno,
//             shipperDetails: false,
//         };

//         try {
//             const response = await axios.get(apiUrl, {
//                 params,
//                 headers: {
//                     Authorization: "Bearer "+authToken,//`Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjpbIlRyYWNrIiwiRWNvbSJdLCJjbGllbnRpZCI6IjIxNTYxMDA1OSIsInNlcnZpY2VzIjoiIiwiZXhjbHVkZWQtc2VydmljZXMiOiIiLCJpc3MiOiJ1YXQtbWlkZGxld2FyZS50cmFuenVtcGsuY29tIiwianRpIjoiYWI4MTVmMDEtNDRhOC00MjhlLWI0MGYtNTA5NzRmZTQwN2QyIiwibmJmIjoxNzM0MDc2NDA4LCJleHAiOjE4MjA0NzY0MDgsImlhdCI6MTczNDA3NjQwOH0.Vj2LvEk98Ii72pWaOOsLMu7AfhNJ3WNPdmiyybQ7aAc`,
//                     Accept: '*/*',
//                 },
//                 responseType: 'blob', // Ensure the response is treated as a file
//             });
//             console.log("response",response.data);

//             const url = window.URL.createObjectURL(new Blob([response.data]));
//             const link = document.createElement('a');
//             link.href = url;
//             link.setAttribute('download', `invoice_${consignmentno}.pdf`);
//             document.body.appendChild(link);
//             link.click();
//             link.remove();
//         } catch (error) {//Maheen OLX
//             MySwal.fire('Error', 'Failed to download the file. Please try again.', 'error');
//         }
//     };
//     const handleCancel = async (record, courierType, consignmentno) => {
//         if (!consignmentno) {
//             MySwal.fire('Error', 'Please select a valid record with a consignment number.', 'error');
//             return;
//         }
//         const cour = getCourierDetails(record?.shippingAddress?.country || "Pakistan", record.storeId || "", courierType || "", courierList || null);
//         console.log("cour",cour);
//         const {baseUrl, authToken, accessToken} = cour;
// console.log("authToken",authToken);
// console.log("accessToken",accessToken);
//         const apiUrl = baseUrl+ 'booking/cancel';//`https://devconnect.tcscourier.com/ecom/api/booking/cancel`;
//         const data = {
//             accesstoken: accessToken,//'jcgwsU85g+loIFikVpysYT4QQ1WUQ/0sycayn1fOKUHbanhNc4Hix21+9FtBgTNT+17xcw8hCA/m0WKWvjlWdkCRRamFiwoEIcst9yGRPksWtzlYzAeo2sIQBv6vbf8H9v1FjLDWB1vgfwuupewDYhB4xoPKGpg17elVfxdpJPM=',
//             consignmentnumber: consignmentno
//         };

//         try {
//             const response = await axios.post(apiUrl, data, {
//                 headers: {
//                     accept: '*/*',
//                     Authorization: "Bearer "+authToken,//eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjpbIlRyYWNrIiwiRWNvbSJdLCJjbGllbnRpZCI6IjIxNTYxMDA1OSIsInNlcnZpY2VzIjoiIiwiZXhjbHVkZWQtc2VydmljZXMiOiIiLCJpc3MiOiJ1YXQtbWlkZGxld2FyZS50cmFuenVtcGsuY29tIiwianRpIjoiYWI4MTVmMDEtNDRhOC00MjhlLWI0MGYtNTA5NzRmZTQwN2QyIiwibmJmIjoxNzM0MDc2NDA4LCJleHAiOjE4MjA0NzY0MDgsImlhdCI6MTczNDA3NjQwOH0.Vj2LvEk98Ii72pWaOOsLMu7AfhNJ3WNPdmiyybQ7aAc`,
//                     'Content-Type': 'application/json-patch+json',
//                 },
//             });
//             console.log("handleCancel response",response);
//             await axios.post('updateconsignmentnobyorderid/', {_id: record._id,consignmentNo: null });

//             fetchOrders();
//         } catch (error) {//Maheen OLX
//             MySwal.fire('Error', 'Failed to download the file. Please try again.', 'error');
//         }
//     };
    
//     useEffect(() => {
//         async function fetchInitialData() {
//             try {
//                 const [suppliers, products] = await Promise.all([
//                     axios.get('getusersuppliers/'),
//                     axios.get('getuserproducts/')
//                 ]);

//                 dispatch(set_supplier_list(suppliers.data));
//                 dispatch(set_product_list(products.data));

//                 const storeOptionsList = localStorage.getItem('storeOptionsList');
//                 if (storeOptionsList) {
//                     setStoreOption(JSON.parse(storeOptionsList));
//                 }
//             } catch (error) {
//                 console.error("Error fetching initial data:", error);
//             }
//         }
//         fetchInitialData();
//     }, [dispatch]);

//     const columns = [
//         {
//             title: translation[language]?.["order_number"] || "Order Number",
//             dataIndex: "_id",
//         },
//         {
//             title: translation[language]?.["customer"] || "Customer",
//             dataIndex: "shippingAddress",
//             render: (text) => <span>{text?.name || ""}</span>,
//         },
//         {
//             title: translation[language]?.["date"] || "Date",
//             dataIndex: "createdAt",
//             render: (text) => <span>{dateFormatter(text, language)}</span>,
//         },
//         {
//             title: translation[language]?.["payment_status"] || "Payment Status",
//             dataIndex: "saleStatus",
//             render: (text) => {
//                 const statusStyles = {
//                     received: { backgroundColor: "#3D8E03", color: "white" },
//                     pending: { backgroundColor: "#EBAC0A", color: "white" },
//                     returned: { backgroundColor: "#E30404", color: "white" },
//                     default: { backgroundColor: "#E30404", color: "white" },
//                 };
//                 return (
//                     <span className="badge-linesuccess capitalize" style={statusStyles[text] || statusStyles.default}>
//                         {translation[language]?.[text.toLowerCase()] || text}
//                     </span>
//                 );
//             },
//         },
//         {
//             title: translation[language]?.["order_status"] || "Order Status",
//             dataIndex: "transitStatus",
//             render: (text) => {
//                 const statusStyles = {
//                     Packing: { backgroundColor: "#CD31E7", color: "white" },
//                     ConfirmOrder: { backgroundColor: "#0d6efd", color: "white" },
//                     Shipped: { backgroundColor: "#EBAC0A", color: "white" },
//                     Delivered: { backgroundColor: "#3D8E03", color: "white" },
//                     Cancelled: { backgroundColor: "#E30404", color: "white" },
//                     Refunded: { backgroundColor: "brown", color: "white" },
//                     default: { backgroundColor: "#E30404", color: "white" },
//                 };
//                 return (
//                     <span className="badge-linesuccess capitalize" style={statusStyles[text] || statusStyles.default}>
//                         {translation[language]?.[text.toLowerCase()] || text}
//                     </span>
//                 );
//             },
//         },
//         // {
//         //     title: translation[language]?.["Generate_Courier_Label"] || "Generate Courier Label",
//         //     render: (text, record) => (
//         //       <>
//         //         {!record.consignmentNo ?(
//         //         <button onClick={() => handleGenerateInvoice(record, 'tcs')} className="btn btn-primary">
//         //             {translation[language]?.["create_tcs_booking"] || "Create Tcs Booking"}
//         //         </button>
//         //     ):(
//         //         <>
//         //         <button onClick={() => handleCancel(record, 'tcs', record._id,record.consignmentNo?record.consignmentNo:"173000144860")} className="btn btn-primary me-2">
//         //             {translation[language]?.["cancel_booking"] || "Cancel Booking"}
//         //         </button>

//         //         <button onClick={() => handleDownload(record, 'tcs', record.consignmentNo?record.consignmentNo:"173000144860")} className="btn btn-primary">
//         //             {translation[language]?.["download_label"] || "Download Label"}
//         //         </button>
//         //     </>

//         //     )}</>
//         //     ),
//         // },
//         {
//             title: translation[language]?.["total"] || "Total",
//             dataIndex: "grossTotal",
//         },
//         {
//             title: translation[language]?.["action"] || 'Actions',
//             dataIndex: 'actions',
//             render: (text, record) => (
//                 <td className="action-table-data">
//                     <div className="edit-delete-action">
//                         {canUpdate && (
//                             <Link
//                                 className="me-2 p-2"
//                                 onClick={() => setSelectedRecord(record)}
//                                 data-bs-toggle="modal"
//                                 data-bs-target="#add-units"
//                             >
//                                 <i data-feather="edit" className="feather-edit" />
//                             </Link>
//                         )}
//                         {canDelete && (
//                             <Link className="confirm-text p-2" to="#" onClick={() => showConfirmationAlert(record)}>
//                                 <i data-feather="trash-2" className="feather-trash-2" />
//                             </Link>
//                         )}
//                     </div>
//                 </td>
//             ),
//         },
//     ];
    
//     if (courierList?.length > 0) {
//         columns.push({
//             title: translation[language]?.["Generate_Courier_Label"] || "Generate Courier Label",
//             render: (text, record) => (
//                 <>
//                     {!record.consignmentNo ? (
//                         <button
//                             onClick={() => handleGenerateInvoice(record, 'tcs')}
//                             className="btn btn-primary"
//                         >
//                             {translation[language]?.["create_tcs_booking"] || "Create Tcs Booking"}
//                         </button>
//                     ) : (
//                         <>
//                             <button
//                                 onClick={() =>
//                                     handleCancel(
//                                         record,
//                                         'tcs',
//                                         record._id,
//                                         record.consignmentNo || "173000144860"
//                                     )
//                                 }
//                                 className="btn btn-primary me-2"
//                             >
//                                 {translation[language]?.["cancel_booking"] || "Cancel Booking"}
//                             </button>
    
//                             <button
//                                 onClick={() =>
//                                     handleDownload(record, 'tcs', record.consignmentNo || "173000144860")
//                                 }
//                                 className="btn btn-primary"
//                             >
//                                 {translation[language]?.["download_label"] || "Download Label"}
//                             </button>
//                         </>
//                     )}
//                 </>
//             ),
//         });
//     }
//     const filteredDataSource = selectedStore
//         ? dataSource.filter(order => order.storeId === selectedStore)
//         : dataSource;

//     const showConfirmationAlert = (record) => {
//         MySwal.fire({
//             title: translation[language]?.["are_you_sure?"] || "Are you sure?",
//             text: translation[language]?.["you_won't_be_able_to_revert_this!"] || "You won't be able to revert this!",
//             showCancelButton: true,
//             confirmButtonColor: "#00ff00",
//             confirmButtonText: translation[language]?.["yes,_delete_it!"] || "Yes, delete it!",
//             cancelButtonColor: "#ff0000",
//             cancelButtonText: translation[language]?.["cancel"] || "Cancel",
//         }).then(async (result) => {
//             if (result.isConfirmed) {
//                 try {
//                     await axios.post("removeorder/", record);
//                     dispatch(set_page_refresh("saleslist"));
//                     MySwal.fire({
//                         title: translation[language]?.["deleted!"] || "Deleted!",
//                         text: translation[language]?.["item_has_been_deleted."] || "Item has been deleted.",
//                         confirmButtonText: translation[language]?.["ok"] || "OK",
//                     });
//                 } catch (e) {
//                     console.error(e);
//                 }
//             }
//         });
//     };

//     return (
//         <div>
//             {canView ? (
//                 <div className={`${language === 'ar' ? 'page-wrapper-rtl' : 'page-wrapper'}`}>
//                     <div className="content">
//                         <div className="page-header">
//                             <h4>{translation[language]?.["orders_list"] || "Orders List"}</h4>
//                             <h6>{translation[language]?.["manage_your_orders"] || "Manage Your Orders"}</h6>
//                             <Select
//                                 className="select"
//                                 options={storeOption}
//                                 value={storeOption.find(option => option.value === selectedStore)}
//                                 onChange={(option) => setSelectedStore(option.value)}
//                                 placeholder={translation[language]?.["all_stores"] || "All Stores"}
//                                 styles={{ container: (provided) => ({ ...provided, minWidth: '200px' }) }}
//                             />
//                         </div>
//                         <div className="card table-list-card">
//                             <div className="card-body">
//                                 <div className="table-responsive">
//                                     <Table columns={columns} dataSource={filteredDataSource} />
//                                 </div>
//                             </div>
//                         </div>
//                         <EditSales record={selectedRecord} />
//                     </div>
//                 </div>
//             ) : (
//                 <div>
//                     <p>{translation[language]?.["you_don't_have_permission_to_view_this_page"] || "You don't have permission to view this page"}</p>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default SalesList;
